import React from 'react';
// Applies the fixed film-grain overlay (see .grain::after in index.css).
export default function Grain() {
  return <div className="grain" aria-hidden="true" />;
}
